module.exports = __webpack_public_path__ + "static/media/List_Black.c4446d8c.svg";